const preloader = document.querySelector('.preloader')

function fadeLoaderEffect() {
  setInterval(function() {
    if (!preloader.style.opacity) {
      preloader.style.opacity = 1
    }
    if (preloader.style.opacity > 0) {
      preloader.style.opacity -= 0.1
    } else {
      preloader.style.display = 'none'
      clearInterval(fadeLoaderEffect)
    }
  }, 50)
}

if (preloader) {
  window.addEventListener('load', fadeLoaderEffect)
}
